<template>
    <div id="ueberDieApp">
        <h1>Über die App</h1>

        <h2>⚠️ Rechtlicher Hinweis (Disclaimer):</h2>
        <p>Diese App ist ein <strong>privates Projekt</strong> und steht <strong>in keinem Zusammenhang mit einer offiziellen staatlichen Stelle</strong>, einer öffentlichen Einrichtung oder einer Feuerwehr-Behörde.</p>
        <p>Die Inhalte dieser App dienen ausschließlich der <strong>internen Schulung, Organisation und Unterstützung</strong> von Feuerwehrkräften im nicht-amtlichen Rahmen.</p>
        <p>Alle bereitgestellten Informationen wurden <strong>eigenständig recherchiert</strong> und können unvollständig oder fehlerhaft sein. Sie ersetzen <strong>keine offiziellen Informationen oder Systeme</strong> von Behörden oder Einsatzleitungen.</p>

        <h2>Quellen:</h2>
        <p>Die Inhalte basieren auf eigenen Erfahrungen, öffentlich zugänglichen Schulungsmaterialien sowie unabhängigen Ressourcen aus dem Feuerwehrbereich.</p>
 
        <router-link :to="`/`+this.$route.params.id"><button id="homeButton" class="mapButton"><img src="@/assets/Icons/HomeButton.svg"></button></router-link>
 </div>
</template>

<style lang="scss">
    #ueberDieApp{
        background-color: white;
        padding-bottom: 3rem;

        #homeButton{
        position: fixed;
        //bottom: -2.7rem;
        bottom: 1.5rem;
        left: 50%;
        transform: translateX(-50%);
    }

    .mapButton{
        width: 3.5rem;
        height: 3.5rem;
        box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.11);
        background-color: white;
        z-index: 400;
        border: none;
        border-radius: 90px;
        transition: transform 0.3s ease;

        img{
            height: 60%;
            margin: auto;
        }
    }
    }
</style>